// simple token Jaccard similarity 0..1
export function jaccardSim(a, b) {
  const toks = s => (s || "").toLowerCase().replace(/[^a-z0-9\s]/g," ").split(/\s+/).filter(Boolean);
  const A = new Set(toks(a)), B = new Set(toks(b));
  if (A.size === 0 || B.size === 0) return 0;
  let inter = 0;
  A.forEach(t => { if (B.has(t)) inter++; });
  return inter / (A.size + B.size - inter);
}

